import { ReactNode } from 'react';
import { EventsFilters } from '@/components/dataLocker/EventsFilters';
import { UserFilters } from '@/components/filters/UserFilters/UserFilters';
import { PitchVisSettingsPanel } from '@/components/settings/PitchVisSettingsPanel';
import { useSelectedFilterSetName } from '@/hooks/userFilters/useSelectedFilterSetName';
import { LayoutWithFilters } from '../LayoutWithFilters';

export const DataLockerLayoutWithFilters = ({ children }: { children: ReactNode }) => {
  const filtersTitle = useSelectedFilterSetName();

  return (
    <LayoutWithFilters
      filters={<EventsFilters />}
      filtersTitle={filtersTitle}
      filtersActions={<UserFilters />}
      settingsPanel={<PitchVisSettingsPanel />}
    >
      {children}
    </LayoutWithFilters>
  );
};
